// components/brvm/brvmApi.js — Client API BRVM + helpers de formatage + watchlist.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/brvm`;
const LS_KEY = "aya_brvm_watchlist";

function _token() { return localStorage.getItem("civ_user_token") || ""; }
function _auth() { const t = _token(); return t ? { headers: { Authorization: `Bearer ${t}` } } : null; }

export const fetchTicker = () => axios.get(`${API}/ticker`).then((r) => r.data);
export const fetchOverview = () => axios.get(`${API}/overview`).then((r) => r.data);
export const fetchStocks = (q) => axios.get(`${API}/stocks`, { params: q ? { q } : {} }).then((r) => r.data);
export const fetchStock = (symbol) => axios.get(`${API}/stocks/${symbol}`).then((r) => r.data);
export const fetchHistory = (code, period) => axios.get(`${API}/history`, { params: { code, period } }).then((r) => r.data);
export const fetchNews = (q) => axios.get(`${API}/news`, { params: q ? { q } : {} }).then((r) => r.data);

function _localWatch() {
  try { return new Set(JSON.parse(localStorage.getItem(LS_KEY) || "[]")); } catch { return new Set(); }
}

export async function getWatchlist() {
  const auth = _auth();
  if (auth) {
    try { const { data } = await axios.get(`${API}/watchlist`, auth); return new Set(data.symbols || []); } catch { /* fallback local */ }
  }
  return _localWatch();
}

export async function toggleWatch(symbol) {
  const auth = _auth();
  if (auth) {
    try { const { data } = await axios.post(`${API}/watchlist/toggle`, { symbol }, auth); return data.followed; } catch { /* fallback local */ }
  }
  const set = _localWatch();
  const followed = !set.has(symbol);
  if (followed) set.add(symbol); else set.delete(symbol);
  localStorage.setItem(LS_KEY, JSON.stringify([...set]));
  return followed;
}

export const fmtNum = (n, d = 0) =>
  n == null ? "—" : Number(n).toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: Math.max(d, 2) });

export const fmtPct = (p) => (p == null ? "—" : `${p > 0 ? "+" : ""}${Number(p).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %`);

export const fmtCompact = (v) => {
  if (v == null) return "—";
  if (v >= 1e12) return `${(v / 1e12).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} T`;
  if (v >= 1e9) return `${(v / 1e9).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} Mds`;
  if (v >= 1e6) return `${(v / 1e6).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} M`;
  return Number(v).toLocaleString("fr-FR");
};

export const deltaColor = (p) => (p == null || p === 0 ? "#9DB4A6" : p > 0 ? "#34D399" : "#F87171");
export const deltaArrow = (p) => (p == null || p === 0 ? "" : p > 0 ? "↗\uFE0E" : "↘\uFE0E");

const TILE_PALETTE = ["#F97316", "#0E7A4F", "#1D4ED8", "#B45309", "#7C3AED", "#0E7490", "#BE185D", "#4D7C0F"];
const TILE_OVERRIDES = { SNTS: "#FF7900", ORAC: "#FF7900", ECOC: "#0A6EB4", ONTBF: "#00AEEF", CBIBF: "#1B3764", SIBC: "#C8102E" };
export function tileColor(symbol) {
  if (TILE_OVERRIDES[symbol]) return TILE_OVERRIDES[symbol];
  let h = 0;
  for (const c of String(symbol)) h = (h * 31 + c.charCodeAt(0)) % 997;
  return TILE_PALETTE[h % TILE_PALETTE.length];
}

export function tileInitials(shortName, symbol) {
  const words = String(shortName || symbol).split(/\s+/).filter(Boolean);
  return (words.length >= 2 ? words[0][0] + words[1][0] : String(symbol).slice(0, 2)).toUpperCase();
}
